export default "__VITE_ASSET__76fcad58__"